import script from "./BaseOrderDialog.vue?vue&type=script&setup=true&name=BaseOrderDialog&lang=js"
export * from "./BaseOrderDialog.vue?vue&type=script&setup=true&name=BaseOrderDialog&lang=js"

const __exports__ = script;

export default __exports__